import { render, staticRenderFns } from "./ForgotPasswordNaccu.vue?vue&type=template&id=112c539c&scoped=true"
import script from "./ForgotPasswordNaccu.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordNaccu.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordNaccu.vue?vue&type=style&index=0&id=112c539c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112c539c",
  null
  
)

export default component.exports